const defaultState = {
    user: [],
}

const ADD_USER = "ADD_USER";
const REMOVE_USER = "REMOVE_USER";
const CLEAR_USER = "CLEAR_USER";
const FETCH_USER = "FETCH_USER";

export const userReducer = (state = defaultState, action) => {
    switch(action.type) {
        case ADD_USER:
            return {...state, user: [...state.user, action.payload]};
        case REMOVE_USER:
            return {...state, user: [...state.user.filter((id) => id !== action.payload)]};
        case CLEAR_USER:
            return {...state, user: [...state.user = []]};
        case FETCH_USER:
            return {...state, user: [...state.user, ...action.payload]};
        default:
            return state;
    }
}

export const addUserAction = (payload) => ({type: ADD_USER, payload});
export const removeUserAction = (payload) => ({type: REMOVE_USER, payload});
export const clearUserAction = (payload) => ({type: CLEAR_USER, payload});
export const fetchUserAction = (payload) => ({type: FETCH_USER, payload});